import { useState, useCallback } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import pagosYLiquidacionesService from '../services/pagosYRetencionesService';
import { downloadBlob } from '@Shared/Utils/download';

const usePagosYRetenciones = () => {
  const [searchParams, setSearchParams] = useState(null);

  const query = useQuery({
    queryKey: ['pagosYRetenciones', searchParams],
    queryFn: () => pagosYLiquidacionesService.getPagosYLiquidaciones(searchParams),
    enabled: searchParams !== null
  });

  const fetchPagosYRetenciones = useCallback((params) => {
    setSearchParams(params);
  }, []);

  const downloadCertificadoMutation = useMutation({
    mutationFn: ({ cuit, numeroPago, tipoCertificado }) =>
      pagosYLiquidacionesService.downloadCertificado(cuit, numeroPago, tipoCertificado)
      .then((response) => response.blob())
      .then((blob) => {
        downloadBlob(blob, `${tipoCertificado}_${numeroPago}_Certificado.pdf`);
      })
  });

  const downloadCertificado = useCallback(async (cuit, numeroPago, tipoCertificado) => {
    try {
      await downloadCertificadoMutation.mutateAsync({ cuit, numeroPago, tipoCertificado });
      return { success: true };
    } catch (err) {
      console.error('Error downloading certificado:', err);
      return { success: false, error: err.message };
    }
  }, [downloadCertificadoMutation]);

  const exportToExcelMutation = useMutation({
    mutationFn: (params) =>
      pagosYLiquidacionesService.exportPagosYLiquidaciones(params)
      .then((response) => response.blob())
      .then((blob) => {
        downloadBlob(blob, 'PagosYLiquidaciones.xlsx');
      })
  });

  const exportToExcel = useCallback(async (params) => {
    try {
      await exportToExcelMutation.mutateAsync(params);
      return { success: true };
    } catch (err) {
      console.error('Error exporting to Excel:', err);
      return { success: false, error: err.message };
    }
  }, [exportToExcelMutation]);

  return {
    data: query.data?.data ?? [],
    totalItems: query.data?.total ?? 0,
    loading: query.isFetching || downloadCertificadoMutation.isPending || exportToExcelMutation.isPending,
    error: query.error?.message ?? null,
    fetchPagosYRetenciones,
    downloadCertificado,
    exportToExcel
  };
};

export default usePagosYRetenciones;
